declare let ENVIRONMENT: 'prod' | 'ci' | 'dev'

const buildTestSelector =
    // eslint-disable-next-line import/order
    ENVIRONMENT === 'prod' ? require('./buildTestSelector.prod') : require('./buildTestSelector.dev')

export default buildTestSelector.build
